import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { MyTeamGQL, Team } from '../../../../graphql/generated';
import { MemberService } from './member.service';

/**
 * Resolves whether the logged-in agent is the active captain of a team that has the active,
 * TCV-based assist bonus enabled — the gate for showing the "Mijn Team" claim UI.
 *
 * Uses the `myTeam` query, which searches across every establishment the captain has an employee
 * record in — captaincy must not depend on whichever establishment happens to be active in the
 * session (a captain's team can live in a different establishment than the session's active one).
 */
@Injectable({
    providedIn: 'root',
})
export class TeamCaptainService {

    public readonly myActiveBonusTeam$: Observable<Team | null> = this.memberService.employeeId$.pipe(
        distinctUntilChanged(),
        switchMap((employeeId): Observable<Team | null> => {
            if (!employeeId) {
                return of(null);
            }

            return this.myTeamGQL.fetch({}, { fetchPolicy: 'network-only' }).pipe(
                map(result => {
                    const team = (result.data.myTeam ?? null) as Team | null;
                    return team && team.isActive && team.activeBonusEnabled ? team : null;
                }),
            );
        }),
    );

    constructor(
        private readonly myTeamGQL: MyTeamGQL,
        private readonly memberService: MemberService,
    ) {}
}
